import isUndefined from 'lodash/isUndefined';

import { INTEGRATION_TYPES } from './buildTableData';
import INTEGRATION_STATUS from './INTEGRATION_STATUS';

export default function determineIntegrationStatus(integrationRow) {
  const disabledInIon = integrationRow.pipelineIntegration?.disabled;
  const disabledOnCluster = integrationRow.disabled;

  if (integrationRow.type === INTEGRATION_TYPES.UNMANAGED) {
    return INTEGRATION_STATUS.CLI_MANAGED;
  }

  if (integrationRow.stagedForDelete) {
    return disabledOnCluster
      ? INTEGRATION_STATUS.STAGED_FOR_DELETE_PAUSED
      : INTEGRATION_STATUS.STAGED_FOR_DELETE_ACTIVE;
  }

  if (isUndefined(integrationRow.deployedRevision)) {
    return INTEGRATION_STATUS.NOT_DEPLOYED;
  }

  if (disabledInIon && !disabledOnCluster) {
    return INTEGRATION_STATUS.STAGED_FOR_PAUSE;
  }

  if (!disabledInIon && disabledOnCluster) {
    return INTEGRATION_STATUS.STAGED_FOR_ACTIVATION;
  }

  return disabledInIon ? INTEGRATION_STATUS.PAUSED : INTEGRATION_STATUS.ACTIVE;
}
